// Schema markup utilities for SEO
// LocalBusiness and FAQ schema for service pages

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "HVACBusiness",
  "name": "ComfortMaster Heating & Air",
  "image": "https://comfortmasterheating.com/images/logo.png",
  "url": "https://comfortmasterheating.com",
  "telephone": "(859) 255-0728",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "51 Wichita Drive",
    "addressLocality": "Nicholasville",
    "addressRegion": "KY",
    "postalCode": "40356",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 37.8806,
    "longitude": -84.5569
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Saturday", "Sunday"],
      "opens": "00:00",
      "closes": "00:00",
      "description": "24/7 Emergency Service Available"
    }
  ],
  "sameAs": [
    "https://www.facebook.com/comfortmasterheatingandair",
    "https://www.instagram.com/comfortmasterheating",
    "https://www.tiktok.com/@comfortmasterheating"
  ],
  "areaServed": [
    { "@type": "City", "name": "Lexington", "addressRegion": "KY" },
    { "@type": "City", "name": "Nicholasville", "addressRegion": "KY" },
    { "@type": "City", "name": "Georgetown", "addressRegion": "KY" },
    { "@type": "City", "name": "Richmond", "addressRegion": "KY" },
    { "@type": "City", "name": "Frankfort", "addressRegion": "KY" },
    { "@type": "City", "name": "Versailles", "addressRegion": "KY" },
    { "@type": "City", "name": "Winchester", "addressRegion": "KY" },
    { "@type": "City", "name": "Paris", "addressRegion": "KY" },
    { "@type": "City", "name": "Danville", "addressRegion": "KY" },
    { "@type": "City", "name": "Harrodsburg", "addressRegion": "KY" },
    { "@type": "City", "name": "Berea", "addressRegion": "KY" },
    { "@type": "City", "name": "Mt Sterling", "addressRegion": "KY" },
    { "@type": "City", "name": "Lawrenceburg", "addressRegion": "KY" },
    { "@type": "City", "name": "Midway", "addressRegion": "KY" },
    { "@type": "City", "name": "Wilmore", "addressRegion": "KY" },
    { "@type": "City", "name": "Lancaster", "addressRegion": "KY" },
    { "@type": "City", "name": "Cynthiana", "addressRegion": "KY" }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "HVAC Services",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Furnace Repair" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC Repair" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "HVAC Installation" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "HVAC Maintenance" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Heat Pump Services" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Ductless Mini-Splits" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Indoor Air Quality" } }
    ]
  }
};

export function generateFAQSchema(faqs) {
  if (!faqs || faqs.length === 0) return null;
  
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a
      }
    }))
  };
}

export function generateServiceSchema(serviceName, serviceDescription, serviceUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": serviceName,
    "provider": {
      "@type": "HVACBusiness",
      "name": "ComfortMaster Heating & Air",
      "telephone": "(859) 255-0728",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "51 Wichita Drive",
        "addressLocality": "Nicholasville",
        "addressRegion": "KY",
        "postalCode": "40356"
      }
    },
    "areaServed": {
      "@type": "State",
      "name": "Kentucky"
    },
    "description": serviceDescription,
    "url": serviceUrl
  };
}

export function generateBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
}

/**
 * Generate LocalBusiness schema for city pages
 * @param {string} cityName - Name of the city
 * @param {string} county - County name
 * @param {string} citySlug - URL slug for the city
 */
export function generateCityLocalBusinessSchema(cityName, county, citySlug) {
  return {
    "@context": "https://schema.org",
    "@type": "HVACBusiness",
    "name": "ComfortMaster Heating & Air",
    "description": `Expert HVAC services in ${cityName}, ${county}, Kentucky. AC repair, furnace installation, heating and cooling services.`,
    "url": `https://comfortmasterheating.com/service-areas/${citySlug}`,
    "telephone": "(859) 255-0728",
    "email": "info@comfortmasterheating.com",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "51 Wichita Drive",
      "addressLocality": "Nicholasville",
      "addressRegion": "KY",
      "postalCode": "40356",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 37.8806,
      "longitude": -84.5569
    },
    "areaServed": {
      "@type": "City",
      "name": cityName,
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": county
      }
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "07:30",
        "closes": "16:30"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "150"
    }
  };
}

/**
 * Generate Service schema for city pages
 * @param {string} cityName - Name of the city
 * @param {string} serviceType - Type of service (e.g., "HVAC Services")
 */
export function generateCityServiceSchema(cityName, serviceType = "HVAC Services") {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": serviceType,
    "name": `${serviceType} in ${cityName}, KY`,
    "description": `Professional ${serviceType.toLowerCase()} including AC repair, furnace installation, and heating/cooling maintenance in ${cityName}, Kentucky.`,
    "provider": {
      "@type": "HVACBusiness",
      "name": "ComfortMaster Heating & Air",
      "telephone": "(859) 255-0728"
    },
    "areaServed": {
      "@type": "City",
      "name": cityName,
      "addressRegion": "KY"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "HVAC Services",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC Repair" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Furnace Repair" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "HVAC Installation" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Heating Maintenance" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AC Maintenance" } }
      ]
    }
  };
}

/**
 * Generate Article schema for blog posts
 * @param {Object} article - Article data
 */
export function generateArticleSchema(article) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.excerpt,
    "image": article.image,
    "datePublished": article.dateISO || article.date,
    "dateModified": article.dateISO || article.date,
    "author": {
      "@type": "Organization",
      "name": "ComfortMaster Heating & Air",
      "url": "https://comfortmasterheating.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "ComfortMaster Heating & Air",
      "logo": {
        "@type": "ImageObject",
        "url": "https://comfortmasterheating.com/images/assets/logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://comfortmasterheating.com/blog/${article.slug}`
    },
    "articleSection": article.category,
    "wordCount": article.content ? article.content.split(' ').length : 500
  };
}

/**
 * Generate ContactPage schema
 */
export function generateContactPageSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact ComfortMaster Heating & Air",
    "description": "Contact ComfortMaster for HVAC services in Central Kentucky. Get a free estimate for heating, cooling, and air quality services.",
    "url": "https://comfortmasterheating.com/contact",
    "mainEntity": {
      "@type": "HVACBusiness",
      "name": "ComfortMaster Heating & Air",
      "telephone": "(859) 255-0728",
      "email": "info@comfortmasterheating.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "51 Wichita Drive",
        "addressLocality": "Nicholasville",
        "addressRegion": "KY",
        "postalCode": "40356",
        "addressCountry": "US"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "07:30",
          "closes": "16:30"
        }
      ],
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "(859) 255-0728",
          "contactType": "customer service",
          "areaServed": "US-KY",
          "availableLanguage": "English"
        },
        {
          "@type": "ContactPoint",
          "telephone": "(859) 255-0728",
          "contactType": "emergency",
          "areaServed": "US-KY",
          "availableLanguage": "English",
          "hoursAvailable": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            "opens": "00:00",
            "closes": "23:59"
          }
        }
      ]
    }
  };
}


/**
 * Generate FAQPage schema for dedicated FAQ page
 * @param {Object[]} faqs - Array of FAQ objects with question and answer
 */
export function generateFAQPageSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "name": "ComfortMaster Heating & Air - Frequently Asked Questions",
    "description": "Find answers to common HVAC questions about heating, cooling, maintenance, and services in Central Kentucky.",
    "url": "https://comfortmasterheating.com/faq",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
}

/**
 * Generate ItemList schema for Service Areas index page
 * @param {Object[]} cities - Array of city objects with name, slug, and county
 */
export function generateServiceAreasListSchema(cities) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "ComfortMaster HVAC Service Areas in Central Kentucky",
    "description": "Cities and areas served by ComfortMaster Heating & Air in Central Kentucky",
    "url": "https://comfortmasterheating.com/service-areas",
    "numberOfItems": cities.length,
    "itemListElement": cities.map((city, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": `${city.name}, KY`,
      "url": `https://comfortmasterheating.com/service-areas/${city.slug}`,
      "item": {
        "@type": "City",
        "name": city.name,
        "containedInPlace": {
          "@type": "AdministrativeArea",
          "name": city.county
        }
      }
    }))
  };
}

/**
 * Generate WebSite schema for homepage with SearchAction
 */
export function generateWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "ComfortMaster Heating & Air",
    "alternateName": "ComfortMaster HVAC",
    "url": "https://comfortmasterheating.com",
    "description": "Expert HVAC services in Lexington, Nicholasville, and Central Kentucky. AC repair, furnace installation, heating and cooling services since 1999.",
    "publisher": {
      "@type": "Organization",
      "name": "ComfortMaster Heating & Air",
      "logo": {
        "@type": "ImageObject",
        "url": "https://comfortmasterheating.com/images/assets/logo.png"
      }
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://comfortmasterheating.com/blog?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };
}

/**
 * Generate Organization schema for homepage
 */
export function generateOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "HVACBusiness",
    "name": "ComfortMaster Heating & Air",
    "legalName": "ComfortMaster Heating & Air LLC",
    "url": "https://comfortmasterheating.com",
    "logo": "https://comfortmasterheating.com/images/assets/logo.png",
    "image": "https://comfortmasterheating.com/images/assets/team.jpg",
    "description": "Family-owned HVAC company serving Central Kentucky since 1999. Expert heating, cooling, and air quality services.",
    "telephone": "(859) 255-0728",
    "email": "info@comfortmasterheating.com",
    "foundingDate": "1999",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "51 Wichita Drive",
      "addressLocality": "Nicholasville",
      "addressRegion": "KY",
      "postalCode": "40356",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 37.8806,
      "longitude": -84.5569
    },
    "areaServed": {
      "@type": "State",
      "name": "Kentucky"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "sameAs": [
      "https://www.facebook.com/comfortmasterheatingandair",
      "https://www.instagram.com/comfortmasterheating",
      "https://www.tiktok.com/@comfortmasterheating"
    ]
  };
}

/**
 * Generate AggregateRating/Review schema for city pages
 * @param {string} cityName - Name of the city
 * @param {Object[]} reviews - Array of review objects
 */
export function generateReviewSchema(cityName, reviews = []) {
  // Default reviews if none provided
  const defaultReviews = [
    {
      author: "Sarah M.",
      rating: 5,
      date: "2024-10-15",
      text: `Excellent HVAC service in ${cityName}! The technicians were professional and fixed our AC quickly. Highly recommend ComfortMaster.`
    },
    {
      author: "James T.",
      rating: 5,
      date: "2024-09-22",
      text: `ComfortMaster installed a new furnace for us. Great price, excellent work, and very professional team. Best HVAC company in ${cityName}.`
    },
    {
      author: "Linda K.",
      rating: 5,
      date: "2024-08-30",
      text: `Called for emergency AC repair and they came same day. Fair pricing and honest service. Will use again!`
    }
  ];

  const reviewsToUse = reviews.length > 0 ? reviews : defaultReviews;

  return {
    "@context": "https://schema.org",
    "@type": "HVACBusiness",
    "name": "ComfortMaster Heating & Air",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Nicholasville",
      "addressRegion": "KY"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": reviewsToUse.map(review => ({
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": review.author
      },
      "datePublished": review.date,
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": review.rating,
        "bestRating": "5",
        "worstRating": "1"
      },
      "reviewBody": review.text
    }))
  };
}


/**
 * Generate WebPage schema for legal pages (Privacy Policy, Terms, etc.)
 * @param {Object} pageInfo - Page information
 */
export function generateWebPageSchema(pageInfo) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageInfo.name,
    "description": pageInfo.description,
    "url": pageInfo.url,
    "datePublished": pageInfo.datePublished || "2024-04-27",
    "dateModified": pageInfo.dateModified || "2024-04-27",
    "inLanguage": "en-US",
    "isPartOf": {
      "@type": "WebSite",
      "name": "ComfortMaster Heating & Air",
      "url": "https://comfortmasterheating.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "ComfortMaster Heating & Air",
      "logo": {
        "@type": "ImageObject",
        "url": "https://comfortmasterheating.com/images/assets/logo.png"
      }
    },
    "mainEntity": {
      "@type": "HVACBusiness",
      "name": "ComfortMaster Heating & Air",
      "telephone": "(859) 255-0728",
      "email": "info@comfortmasterheating.com"
    }
  };
}


/**
 * Generate Offer schema for specials/promotions
 * @param {Object[]} offers - Array of offer/special objects
 */
export function generateOffersSchema(offers) {
  return {
    "@context": "https://schema.org",
    "@type": "OfferCatalog",
    "name": "ComfortMaster HVAC Specials & Promotions",
    "description": "Current special offers on HVAC services from ComfortMaster Heating & Air",
    "url": "https://comfortmasterheating.com/specials",
    "seller": {
      "@type": "HVACBusiness",
      "name": "ComfortMaster Heating & Air",
      "telephone": "(859) 255-0728"
    },
    "itemListElement": offers.map((offer, index) => ({
      "@type": "Offer",
      "name": offer.title,
      "description": offer.description,
      "priceCurrency": "USD",
      "price": offer.price || "0",
      "priceValidUntil": offer.validUntil || "2025-12-31",
      "availability": "https://schema.org/InStock",
      ...(offer.slug && { "url": `https://comfortmasterheating.com/specials/${offer.slug}` }),
      "itemOffered": {
        "@type": "Service",
        "name": offer.title,
        "provider": {
          "@type": "HVACBusiness",
          "name": "ComfortMaster Heating & Air"
        }
      },
      ...(offer.code && { "eligibleTransactionVolume": { "@type": "PriceSpecification", "name": `Promo Code: ${offer.code}` } })
    }))
  };
}

/**
 * Generate individual Offer schema for a single promotion
 * @param {Object} offer - Single offer/special object
 */
export function generateSingleOfferSchema(offer) {
  return {
    "@context": "https://schema.org",
    "@type": "Offer",
    "name": offer.title,
    "description": offer.description,
    "priceCurrency": "USD",
    "price": offer.price || "99",
    "priceValidUntil": offer.validUntil || "2025-12-31",
    "availability": "https://schema.org/InStock",
    "url": offer.url || "https://comfortmasterheating.com/specials",
    ...(offer.image && { "image": offer.image }),
    "seller": {
      "@type": "HVACBusiness",
      "name": "ComfortMaster Heating & Air",
      "telephone": "(859) 255-0728",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Nicholasville",
        "addressRegion": "KY"
      }
    },
    "itemOffered": {
      "@type": "Service",
      "name": offer.serviceName || offer.title,
      "serviceType": "HVAC Service"
    }
  };
}

/**
 * Generate Product/Service schema for Comfort Loyalty Club membership
 */
export function generateLoyaltyProgramSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "ComfortLoyalty Club Membership",
    "description": "Premium HVAC maintenance membership including seasonal tune-ups, priority scheduling, 10% repair discount, and no overtime charges.",
    "url": "https://comfortmasterheating.com/comfort-loyalty",
    "brand": {
      "@type": "Brand",
      "name": "ComfortMaster Heating & Air"
    },
    "category": "HVAC Maintenance Plan",
    "offers": {
      "@type": "Offer",
      "price": "16.00",
      "priceCurrency": "USD",
      "priceValidUntil": "2025-12-31",
      "availability": "https://schema.org/InStock",
      "url": "https://comfortmasterheating.com/comfort-loyalty/sign-up",
      "seller": {
        "@type": "HVACBusiness",
        "name": "ComfortMaster Heating & Air"
      },
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "price": "16.00",
        "priceCurrency": "USD",
        "billingDuration": {
          "@type": "QuantitativeValue",
          "value": "1",
          "unitCode": "MON"
        },
        "billingIncrement": "16.00",
        "unitText": "per month"
      }
    },
    "hasProductReturnPolicy": {
      "@type": "ProductReturnPolicy",
      "productReturnDays": "30"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "75",
      "bestRating": "5"
    },
    "additionalProperty": [
      { "@type": "PropertyValue", "name": "Seasonal Tune-Ups", "value": "2 per year (heating & cooling)" },
      { "@type": "PropertyValue", "name": "Priority Scheduling", "value": "Included" },
      { "@type": "PropertyValue", "name": "Repair Discount", "value": "10% off all repairs" },
      { "@type": "PropertyValue", "name": "Overtime Charges", "value": "None" }
    ]
  };
}

/**
 * Generate VideoObject schema for embedded videos
 * @param {Object} video - Video details object
 */
export function generateVideoSchema(video) {
  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": video.title,
    "description": video.description,
    "thumbnailUrl": video.thumbnail,
    "uploadDate": video.uploadDate,
    "duration": video.duration, // ISO 8601 format, e.g., "PT2M30S"
    "contentUrl": video.url,
    "embedUrl": video.embedUrl,
    "publisher": {
      "@type": "Organization",
      "name": "ComfortMaster Heating & Air",
      "logo": {
        "@type": "ImageObject",
        "url": "https://comfortmasterheating.com/images/assets/logo.png"
      }
    },
    ...(video.transcript && { "transcript": video.transcript })
  };
}

/**
 * Generate Event schema for seasonal promotions
 * @param {Object} event - Event details
 */
export function generateEventSchema(event) {
  return {
    "@context": "https://schema.org",
    "@type": "SaleEvent",
    "name": event.name,
    "description": event.description,
    "url": event.url || "https://comfortmasterheating.com/specials",
    "startDate": event.startDate,
    "endDate": event.endDate,
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
    "location": {
      "@type": "VirtualLocation",
      "url": "https://comfortmasterheating.com"
    },
    "organizer": {
      "@type": "HVACBusiness",
      "name": "ComfortMaster Heating & Air",
      "url": "https://comfortmasterheating.com",
      "telephone": "(859) 255-0728"
    },
    "offers": {
      "@type": "Offer",
      "name": event.offerName || event.name,
      "price": event.price || "99",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "validFrom": event.startDate,
      "url": event.url || "https://comfortmasterheating.com/specials"
    }
  };
}

/**
 * Generate Fall Maintenance Event schema
 */
export function generateFallMaintenanceEventSchema() {
  const currentYear = new Date().getFullYear();
  return generateEventSchema({
    name: "Fall HVAC Maintenance Special",
    description: "Get your heating system ready for winter with our $99 Fall Furnace Tune-Up. Includes 21-point inspection, filter replacement, and safety check. Save $40!",
    url: "https://comfortmasterheating.com/specials",
    startDate: `${currentYear}-09-01`,
    endDate: `${currentYear}-11-30`,
    offerName: "Fall Furnace Tune-Up",
    price: "99"
  });
}

/**
 * Generate Spring AC Maintenance Event schema
 */
export function generateSpringMaintenanceEventSchema() {
  const currentYear = new Date().getFullYear();
  return generateEventSchema({
    name: "Spring AC Maintenance Special",
    description: "Prepare your cooling system for summer with our $99 AC Tune-Up. Includes comprehensive inspection, cleaning, and refrigerant check. Save $40!",
    url: "https://comfortmasterheating.com/specials",
    startDate: `${currentYear}-03-01`,
    endDate: `${currentYear}-05-31`,
    offerName: "Spring AC Tune-Up",
    price: "99"
  });
}